// Ensures only one refresh operation is ever in flight at a time. Every
// caller that arrives while a refresh is already running awaits the SAME
// promise instead of firing its own request — this is what turns "N
// simultaneous 401s" into exactly one network call to /api/auth/refresh,
// with every caller resolving/rejecting together with its outcome.
export function createSingleFlight(worker) {
  let inFlight = null;

  return function run(...args) {
    if (!inFlight) {
      inFlight = worker(...args).finally(() => {
        inFlight = null;
      });
    }

    return inFlight;
  };
}
